import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Tooltip,
  CartesianGrid,
  LabelList
} from "recharts";
import { formatIndianPrice } from "../../formatIndianPrice";

const ReactBarChart = ({ data,color="#fe8d5c" }) => {
  if (!data || !data.chart || !data.chart.data) {
    return <div className="d-flex justify-content-center align-items-center" style={{height:'100%',fontWeight:'500',fontSize:'24px',color:'#391f84'}}>No Data Found</div>;
  }

  // Prepare chart data
  const chartData = data.chart.data.labels.map((label, index) => ({
    name: label,
    value: data.chart.data.datasets[0].values[index] || 0
  }));

  // Custom tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: "6px",
            padding: "8px 12px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
            fontSize: "12px",
          }}
        >
          <p style={{ margin: 0, fontWeight: "bold", color: "#391f84" }}>{label}</p>
          <p style={{ margin: 0, color: "#823455" }}>
            ₹{formatIndianPrice(payload[0].value)}
          </p>
        </div>
      );
    }
    return null;
  };

  const formatYAxisTick = (value) => `${(value / 100000).toFixed(0)} L`;

  const barColors = ["#391f84", "#823455", "#fe8d5c"];

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart
        data={chartData}
        margin={{ top: 30, right: 30, left: 10, bottom: 10 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
        <XAxis dataKey="name" tick={{ fontSize: 12, fill: "#391f84" }} />
        <YAxis
          tickFormatter={formatYAxisTick}
          tick={{ fontSize: 12, fill: "#391f84" }}
        />
        <Tooltip content={<CustomTooltip />} />
        {/* <Legend wrapperStyle={{ fontSize: "12px" }} /> */}

        <Bar dataKey="value" radius={[6, 6, 0, 0]} fill={color}>
          {chartData.map((_, index) => (
            <cell
              key={`cell-${index}`}
              fill={barColors[index % barColors.length]}
            />
          ))}
          <LabelList
            dataKey="value"
            position="top"
            formatter={(value) => `${(value / 100000).toFixed(0)} L`}
            style={{ fontSize: "10px", fill: "#823455" }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default ReactBarChart;
